import React from "react";
import { Box, Chip } from "@mui/material";
import { TagChipAvatar } from "../../../pages/puzzles/common/components/TagChipAvatar";
import { puzzleTagRowSx } from "../styles/screenshotStyles";

/**
 * Tag chips under the puzzle title on a screenshot scene.
 */
export default function ScreenshotTagBar({ tags = [] }) {
    const list = (tags ?? [])
        .filter((tag) => String(tag).trim().toLowerCase() !== "bedrock")
        .map((tag) => String(tag).trim().toLowerCase());

    if (list.length === 0) return null;

    return (
        <Box sx={puzzleTagRowSx}>
            {list.map((tag) => (
                <Chip
                    key={tag}
                    avatar={<TagChipAvatar tag={tag} size={18} />}
                    label={tag}
                    size="small"
                    variant="outlined"
                    sx={{ fontSize: "0.85rem", height: 32 }}
                />
            ))}
        </Box>
    );
}
